module.exports = __webpack_public_path__ + "static/media/close.d5684a40.svg";